// src/components/25.js
import React from 'react';

const Componente25 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 25</h2>
      <p>
        Para una persona nacida el día 25, el número de propósito asociado sería 25.
      </p>
      <p>
        En numerología, el número 25 está vinculado a la intuición, la sabiduría y la búsqueda del conocimiento. Las personas nacidas en este día suelen tener un enfoque profundo y reflexivo sobre la vida. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Desarrollar la Intuición:</strong> Estas personas están destinadas a confiar en su intuición y a utilizarla como guía en su vida.</li>
        <li><strong>Buscar el Conocimiento:</strong> Su propósito puede incluir la búsqueda constante de conocimiento y entendimiento en diversas áreas.</li>
        <li><strong>Compartir Sabiduría:</strong> Tienen el potencial de compartir su conocimiento y experiencias con otros, actuando como mentores o guías.</li>
        <li><strong>Fomentar la Reflexión:</strong> Su enfoque en la introspección les permite ayudar a otros a reflexionar sobre sus propias vidas y decisiones.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 25</h3>
      <ul>
        <li><strong>Intuitivos:</strong> Tienen una fuerte conexión con su voz interior y saben escucharla.</li>
        <li><strong>Sabios:</strong> Su capacidad para comprender y procesar información les permite ofrecer perspectivas valiosas.</li>
        <li><strong>Reflexivos:</strong> Disfrutan de la contemplación y a menudo buscan el significado más profundo de las experiencias.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 25 son intuitivas y sabias, con un propósito que se centra en la búsqueda del conocimiento y la reflexión. Su habilidad para compartir su sabiduría y guiar a otros les permite dejar un impacto significativo en la vida de quienes los rodean.
      </p>
    </div>
  );
};

export default Componente25;
